import React from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { useEditOrgAdmin } from "./useEditOrgAdmin";

interface IProps {
  orgId: string;
  email: string;
  phoneNo: string;
  orgName: string;
  address: string;
}

const EditOrgAdmin = (props: IProps) => {
  const {
    show,
    setNewPhoneNo,
    setNewAddress,
    handleClose,
    handleShow,
    newPhoneNo,
    newAddress,
    handleEdit,
    isDisabled,
    handleKeyDown
  } = useEditOrgAdmin(props);
  const { email, orgName } = props;

  return (
    <>
      <div onClick={handleShow}>
        <span>Edit</span>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        className="modal-container create-new-org-admin"
        centered
      >
        <Form>
          <Modal.Header closeButton>
            <Modal.Title>Edit Org Admin</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="add-group-container">
              <div className="create-new-org-admin">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Organization Name</Form.Label>
                  <Form.Control type="text" value={orgName} disabled />
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Organization Admin Email</Form.Label>
                  <Form.Control type="email" value={email} disabled />
                </Form.Group>

                <Form.Group className="mb-3" controlId="phoneNumber">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    required
                    type="number"
                    aria-describedby="phoneNumber"
                    value={newPhoneNo}
                    isInvalid={newPhoneNo?.length==0} 
                    onChange={(e) => setNewPhoneNo(e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide a valid phone number.
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="address" className="mb-3">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    aria-describedby="Address"
                    value={newAddress}
                    isInvalid={newAddress?.length==0} 
                    onChange={(e) => setNewAddress(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide a valid address.
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn-cancel" onClick={handleClose}>
              Cancel
            </Button>
            <Button className="btn-style" onClick={handleEdit} disabled={isDisabled}>
              Edit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default EditOrgAdmin;
